import { render } from "./Details.vue?vue&type=template&id=40ab00ec&scoped=true&ts=true"
import script from "./Details.ts?vue&type=script&lang=ts"
export * from "./Details.ts?vue&type=script&lang=ts"

import "./Details.css?vue&type=style&index=0&id=40ab00ec&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ab00ec"]])

export default __exports__